import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { ReflectionReflectionsBridge } from './bridges/reflection_reflections.bridge';
import { REFLECTIONS_FEATURE_KEY } from './keys';
import { reflectionsReducer } from './reducers/reflections.reducer';
import { ReflectionsEffects } from './effects/reflections.effects';

export function provideReflectionsStore(): EnvironmentProviders[] {
    return [provideState(REFLECTIONS_FEATURE_KEY, reflectionsReducer), provideEffects(ReflectionsEffects, ReflectionReflectionsBridge)];
}
